import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import TermsConditions from "@/pages/TermsConditions";
import CookieConsent from "@/components/CookieConsent";
import { initConsentOnLoad } from "@/lib/consent";

function App() {
  useEffect(() => {
    initConsentOnLoad();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/politica-confidentialitate" element={<PrivacyPolicy />} />
          <Route path="/politica-cookies" element={<CookiePolicy />} />
          <Route path="/termeni-conditii" element={<TermsConditions />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        richColors
        toastOptions={{
          style: { fontFamily: "Manrope, sans-serif" },
        }}
      />
    </div>
  );
}

export default App;
